import React, { useEffect, useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import RateCalcWidget from "./RateCalcWidget";

export default function HomePage() {
  return (
    <div className="">
      <Header />
      <div className="px-8 md:px-12 md:mt-24 md:w-5/6 mx-auto">
        <div className="flex flex-col justify-between py-12">
          <h1 className="text-left text-[#224a61] inline text-[45px] font-semibold leading-[54px]">
            Get Real-Time Mortgage Interest Rates
          </h1>
          <div className="h-1 w-1/3 bg-[#E89410] mt-4 rounded-md"></div>
        </div>
        <div>
          <RateCalcWidget />
        </div>
      </div>
      <Footer />
    </div>
  );
}
